module.exports = __webpack_public_path__ + "static/media/imagem22.9c988db5.jpeg";